import React from "react";
import ScrollReveal from "./ScrollReveal";

const SectionHeader = ({
  title,
  subtitle,
  align = "center",
  accentColor = "blue",
  className = "",
}) => {
  const alignClass =
    align === "left" ? "text-left items-start" : "text-center items-center";

  const accentClasses = {
    blue: "from-blue-600 to-indigo-600 dark:from-blue-400 dark:to-indigo-400",
    red: "from-red-600 to-orange-600 dark:from-red-400 dark:to-orange-400",
    green:
      "from-emerald-600 to-teal-600 dark:from-emerald-400 dark:to-teal-400",
    dark: "from-slate-800 to-slate-950 dark:from-slate-200 dark:to-white",
  };

  const selectedAccent = accentClasses[accentColor] || accentClasses.blue;

  return (
    <div className={`flex flex-col ${alignClass} mb-4 sm:mb-12 ${className}`}>
      <ScrollReveal variants="fade-up" distance={20}>
        {subtitle && (
          <span className="text-blue-600 dark:text-blue-400 font-black tracking-[0.25em] text-[8px] sm:text-xs uppercase mb-1 sm:mb-3 block">
            {subtitle}
          </span>
        )}

        <h2 className="relative inline-block text-xl sm:text-4xl font-black text-slate-900 dark:text-white transition-colors duration-300">
          {title}

          {/* Decorative background shape */}
          <span className="absolute -z-10 -top-4 -left-4 w-12 h-12 bg-blue-100 dark:bg-blue-900/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity"></span>
        </h2>

        <div
          className={`mt-3 sm:mt-4 flex ${align === "left" ? "justify-start" : "justify-center"} items-center gap-2`}
        >
          <div
            className={`h-1 sm:h-1.5 w-8 sm:w-12 rounded-full bg-gradient-to-r ${selectedAccent}`}
          ></div>
          <div className="h-1 sm:h-1.5 w-1 sm:w-1.5 rounded-full bg-slate-300 dark:bg-slate-700"></div>
          <div className="h-1 sm:h-1.5 w-1 sm:w-1.5 rounded-full bg-slate-200 dark:bg-slate-800"></div>
        </div>
      </ScrollReveal>

      <style jsx>{`
        h2 {
          letter-spacing: -0.02em;
        }
      `}</style>
    </div>
  );
};

export default SectionHeader;
